import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CardPedido from "../CardPedido";
import './index.css';
import { api } from '../../services/api';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import { Modal, Button, Form } from 'react-bootstrap';
import RefeicaoPDF from "../RefeicaoPDF/index.jsx";
import Foto from "../../app/Components/Foto";
import Swal from 'sweetalert2';

const fotosCache = new Map();

function LoadingModal({ show, message }) {
    if (!show) return null;
    return (
        <div className="loading-modal-overlay">
            <div className="loading-modal-content">
                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div style={{ marginTop: 15, fontSize: 18, fontWeight: '500', color: '#444' }}>{message}</div>
            </div>
            <style>{`
                .loading-modal-overlay {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.6);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 2000;
                    backdrop-filter: blur(4px);
                }
                .loading-modal-content {
                    background: white;
                    padding: 30px 50px;
                    border-radius: 16px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
                }
            `}</style>
        </div>
    );
}

function Home() {
    const [funcionarios, setFuncionarios] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [pesquisa, setPesquisa] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');

    // ESTADO DOS TOTAIS ACUMULADOS
    const [totaisValores, setTotaisValores] = useState({ aReceber: 0, recebidoAnterior: 0 });

    // CONTROLE DE VISIBILIDADE E SENHA TEMPORÁRIA
    const [valoresOcultos, setValoresOcultos] = useState(() => {
        return localStorage.getItem("valoresOcultosRestaurante") === "true";
    });
    const [showModalSenha, setShowModalSenha] = useState(false);
    const [modoModalSenha, setModoModalSenha] = useState('definir'); // 'definir' ou 'desbloquear'
    const [inputSenha, setInputSenha] = useState('');
    const [inputSenhaConfirma, setInputSenhaConfirma] = useState('');

    // ORDENAÇÃO MULTINÍVEL VIA DRAG & DROP
    const [prioridades, setPrioridades] = useState(() => {
        const cache = localStorage.getItem("prioridadesOrdenacaoRestaurante");
        if (cache) {
            try { return JSON.parse(cache); } catch (e) { console.error(e); }
        }
        return [
            { id: "turno", label: "Turno" },
            { id: "loja", label: "Loja" },
            { id: "nome", label: "Nome" }
        ];
    });

    const [draggedIndex, setDraggedIndex] = useState(null);

    // ESTADOS PARA O CONTADOR DE FOTOS
    const [carregandoFotos, setCarregandoFotos] = useState(false);
    const [fotosCarregadas, setFotosCarregadas] = useState(0);
    const [fotosTotal, setFotosTotal] = useState(0);

    // ESTADO DA CONFIRMAÇÃO DE REFEIÇÃO (COM FOTO)
    const [confirmacao, setConfirmacao] = useState(false);
    const [confirmacaoUsuario, setConfirmacaoUsuario] = useState(null);

    const [erro, setErro] = useState(false);
    const [status, setStatus] = useState('0');
    const [datahora, setData] = useState('');
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const navigate = useNavigate();
    const [codigorest, setCodigoRest] = useState(0);

    function MudarData() {
        const newdata = new Date().toLocaleTimeString();
        setData(newdata);
    }

    // BUSCA OS TOTAIS ACUMULADOS DA SEMANA
    function carregarTotais(codigo) {
        const cod = codigo || codigorest;
        if (!cod) return;
        api.get(`/restaurante/totais/${cod}`)
            .then(res => {
                if (res.data) {
                    setTotaisValores({
                        aReceber: res.data.aReceber || 0,
                        recebidoAnterior: res.data.recebidoAnterior || 0
                    });
                }
            })
            .catch(err => console.log("Erro ao buscar totais:", err));
    }

    // LÓGICA DO BOTÃO EXIBIR/OCULTAR VALORES COM SENHA
    function handleToggleVisibilidade() {
        const senhaSalva = localStorage.getItem("senhaTemporariaRestaurante");

        if (!valoresOcultos) {
            if (!senhaSalva) {
                setModoModalSenha('definir');
                setInputSenha('');
                setInputSenhaConfirma('');
                setShowModalSenha(true);
            } else {
                setValoresOcultos(true);
                localStorage.setItem("valoresOcultosRestaurante", "true");
            }
        } else {
            if (senhaSalva) {
                setModoModalSenha('desbloquear');
                setInputSenha('');
                setShowModalSenha(true);
            } else {
                setValoresOcultos(false);
                localStorage.setItem("valoresOcultosRestaurante", "false");
            }
        }
    }

    function handleSalvarSenhaModal(e) {
        e.preventDefault();

        if (modoModalSenha === 'definir') {
            if (!inputSenha || inputSenha.trim() === '') {
                Swal.fire('Atenção', 'Informe uma senha válida.', 'warning');
                return;
            }
            if (inputSenha !== inputSenhaConfirma) {
                Swal.fire('Erro', 'As senhas não coincidem.', 'error');
                return;
            }
            localStorage.setItem("senhaTemporariaRestaurante", inputSenha);
            localStorage.setItem("valoresOcultosRestaurante", "true");
            setValoresOcultos(true);
            setShowModalSenha(false);
            Swal.fire('Valores Ocultos!', 'Sua senha temporária foi definida com sucesso.', 'success');
        } else {
            const senhaSalva = localStorage.getItem("senhaTemporariaRestaurante");
            if (inputSenha === senhaSalva) {
                setValoresOcultos(false);
                localStorage.setItem("valoresOcultosRestaurante", "false");
                setShowModalSenha(false);
            } else {
                Swal.fire('Senha Incorreta', 'A senha informada não confere.', 'error');
            }
        }
    }

    // COMPARAÇÃO MULTINÍVEL DE ORDENAÇÃO
    function compararMultinivel(a, b, listaPrioridades) {
        for (let item of listaPrioridades) {
            if (item.id === "turno") {
                const tA = Number(a.turno) || 0;
                const tB = Number(b.turno) || 0;
                if (tA !== tB) return tA - tB;
            } else if (item.id === "loja") {
                const lA = Number(a.loja) || 0;
                const lB = Number(b.loja) || 0;
                if (lA !== lB) return lA - lB;
            } else if (item.id === "nome") {
                const cmp = (a.nome || "").localeCompare(b.nome || "");
                if (cmp !== 0) return cmp;
            }
        }
        return 0;
    }

    function ordenarLista(lista, listaPrioridades) {
        return [...lista].sort((a, b) => compararMultinivel(a, b, listaPrioridades));
    }

    // HANDLERS DRAG AND DROP
    const handleDragStart = (index) => {
        setDraggedIndex(index);
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        if (draggedIndex === null || draggedIndex === index) return;

        const novaLista = [...prioridades];
        const itemRemovido = novaLista.splice(draggedIndex, 1)[0];
        novaLista.splice(index, 0, itemRemovido);

        setDraggedIndex(index);
        setPrioridades(novaLista);
    };

    const handleDragEnd = () => {
        setDraggedIndex(null);
        localStorage.setItem("prioridadesOrdenacaoRestaurante", JSON.stringify(prioridades));
        setFuncionarios(prev => ordenarLista(prev, prioridades));
    };

    // CONFIRMAÇÃO DE REFEIÇÃO (ATUALIZA O GRID E OS TOTAIS ACUMULADOS)
    function atualizaRefeicao(chapa) {
        setConfirmacao(false);
        api.post('/restaurante/pedido/' + chapa)
            .then(() => {
                setFuncionarios(funcionarios.filter((t) => t.chapa !== chapa));
                carregarTotais();
            })
            .catch((err) => {
                console.log("Erro na liberação: " + err);
                setLoading(false);
            });
    }

    function confirmDeleteUser(chapa, nome, foto) {
        let fotoFormatada = foto;
        if (foto && !foto.startsWith("data:image") && !foto.startsWith("http")) {
            fotoFormatada = `data:image/jpeg;base64,${foto}`;
        }
        setConfirmacaoUsuario({ chapa, nome, foto: fotoFormatada });
        setConfirmacao(true);
    }

    function abrirModalFoto(foto, nome, chapa) {
        let fotoFormatada = foto;
        if (foto && !foto.startsWith("data:image") && !foto.startsWith("http")) {
            fotoFormatada = `data:image/jpeg;base64,${foto}`;
        }
        setFotoSelecionada({ foto: fotoFormatada, nome, chapa });
    }

    useEffect(() => {
        const cod = localStorage.getItem("codigorest");
        if (cod) setCodigoRest(cod);
    }, []);

    useEffect(() => {
        if (!codigorest) return;
        api.get(`/restaurante/cadastro/${codigorest}`)
            .then(response => {
                const lojasExtraidas = response.data[0]?.lojas || [];
                setLojas(lojasExtraidas);
            })
            .catch(err => {
                console.log("Erro ao carregar lojas:", err);
            });
    }, [codigorest]);

    useEffect(() => {
        if (!codigorest) return;
        setLoading(true);
        setLoadingMessage('Consultando registros...');
        setErro(false);
        setCarregandoFotos(false);

        carregarTotais(codigorest);

        api.get(`/restaurante/pedido/${codigorest}?loja=${pesquisa}&status=${status}`)
            .then(response => {
                const registros = response.data;
                const listaFormatada = registros.map(r => ({ ...r, foto: null }));
                setFuncionarios(ordenarLista(listaFormatada, prioridades));

                setLoading(false);
                localStorage.setItem("codigorest", codigorest);

                const hoje = new Date().toISOString().slice(0, 10);

                const fotosParaBuscar = registros.filter(f => {
                    if (fotosCache.has(f.chapa)) {
                        const { data, foto } = fotosCache.get(f.chapa);
                        if (data === hoje && foto) {
                            setFuncionarios(prev => prev.map(item => item.chapa === f.chapa ? { ...item, foto } : item));
                            return false;
                        }
                    }
                    return true;
                });

                if (fotosParaBuscar.length > 0) {
                    setFotosTotal(fotosParaBuscar.length);
                    setFotosCarregadas(0);
                    setCarregandoFotos(true);

                    const promessasFotos = fotosParaBuscar.map((funcionario) =>
                        api.get(`/usuario/foto/${funcionario.chapa}`)
                            .then(fotoResp => {
                                fotosCache.set(funcionario.chapa, { data: hoje, foto: fotoResp.data.foto });
                                setFuncionarios(prev => prev.map(item => item.chapa === funcionario.chapa ? { ...item, foto: fotoResp.data.foto } : item));
                            })
                            .catch(err => console.log(`Erro foto ${funcionario.chapa}`, err))
                            .finally(() => {
                                setFotosCarregadas(prev => prev + 1);
                            })
                    );

                    Promise.allSettled(promessasFotos).finally(() => {
                        setCarregandoFotos(false);
                    });
                }
            })
            .catch(err => {
                console.log(err);
                setErro(true);
                setLoading(false);
            });
    }, [pesquisa, datahora, status, codigorest]);

    function handleGerarPDF() {
        setLoadingMessage('Gerando arquivo PDF...');
        setLoading(true);
        Promise.resolve(RefeicaoPDF(funcionarios))
            .then(() => setLoading(false))
            .catch((err) => {
                console.log("Erro PDF:", err);
                setLoading(false);
            });
    }

    return (
        <div className="main-wrapper">
            <Menu modulo="REST" />
            <LoadingModal show={loading} message={loadingMessage} />

            <div className="container-fluid pagina-home">

                {/* 💳 CARDS FLUTUANTES DE VALORES ACUMULADOS */}
                <div className="totais-dashboard-container mb-3">
                    <div className="card-total-item a-receber shadow-sm">
                        <div className="total-icon">
                            <i className="fa fa-calculator"></i>
                        </div>
                        <div className="total-info flex-grow-1">
                            <span className="total-title">A Receber (Segunda até Hoje)</span>
                            <span className="total-value text-primary">
                                {valoresOcultos
                                    ? "R$ ••••••"
                                    : `R$ ${totaisValores.aReceber.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                }
                            </span>
                        </div>
                        <button
                            className="btn-toggle-visibilidade"
                            onClick={handleToggleVisibilidade}
                            title={valoresOcultos ? "Exibir Valores" : "Ocultar Valores"}
                        >
                            <i className={`fa ${valoresOcultos ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                        </button>
                    </div>

                    <div className="card-total-item recebido-anterior shadow-sm">
                        <div className="total-icon success">
                            <i className="fa fa-calendar-check-o"></i>
                        </div>
                        <div className="total-info flex-grow-1">
                            <span className="total-title">Recebido (Última Segunda a Domingo)</span>
                            <span className="total-value text-success">
                                {valoresOcultos
                                    ? "R$ ••••••"
                                    : `R$ ${totaisValores.recebidoAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                }
                            </span>
                        </div>
                        <button
                            className="btn-toggle-visibilidade"
                            onClick={handleToggleVisibilidade}
                            title={valoresOcultos ? "Exibir Valores" : "Ocultar Valores"}
                        >
                            <i className={`fa ${valoresOcultos ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                        </button>
                    </div>
                </div>

                {/* 🛠 BARRA DE FERRAMENTAS MODERNA */}
                <div className="toolbar-moderna">
                    <div className="toolbar-top">
                        <button onClick={handleGerarPDF} className="btn-pdf-action">
                            <i className="fa fa-file-pdf"></i> <span>Exportar PDF</span>
                        </button>

                        <div className="toolbar-filtros-right">
                            {/* CAIXA COMPACTA DE ARRASTAR E ORDENAR */}
                            <div className="prioridades-wrapper">
                                <label className="prioridades-label">
                                    <i className="fa fa-arrows-h me-1"></i> Ordenação (Arraste os itens):
                                </label>
                                <div className="prioridades-chips-container">
                                    {prioridades.map((item, index) => (
                                        <div
                                            key={item.id}
                                            draggable
                                            onDragStart={() => handleDragStart(index)}
                                            onDragOver={(e) => handleDragOver(e, index)}
                                            onDragEnd={handleDragEnd}
                                            className={`prioridade-chip ${draggedIndex === index ? 'dragging' : ''}`}
                                        >
                                            <span className="chip-pos">{index + 1}º</span>
                                            <span className="chip-text">{item.label}</span>
                                            <i className="fa fa-bars chip-icon"></i>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* SELETOR DE LOJA */}
                            <div className="loja-selector-wrapper">
                                <label>Loja</label>
                                <select
                                    className="form-select-moderno"
                                    onChange={(e) => setPesquisa(e.target.value)}
                                    value={pesquisa}
                                >
                                    <option value="0">Todas as Unidades</option>
                                    {lojas.map(lj => (
                                        <option key={lj.loja} value={lj.loja}>{lj.loja}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="segmented-control-status">
                        <button
                            className={`segment-btn ${status === '0' ? 'active warning' : ''}`}
                            onClick={() => setStatus('0')}
                        >
                            <i className={status === '0' ? "fa fa-spinner fa-spin" : "fa fa-clock-o"}></i>
                            <span>Pendentes</span>
                        </button>

                        <button
                            className={`segment-btn ${status === '1' ? 'active success' : ''}`}
                            onClick={() => setStatus('1')}
                        >
                            <i className="fa fa-check-circle"></i>
                            <span>Confirmadas</span>
                        </button>

                        <button className="segment-btn refresh" onClick={MudarData}>
                            <i className="fa fa-refresh"></i>
                            <span>{datahora === "" ? "Atualizar" : datahora}</span>
                        </button>
                    </div>
                </div>

                {/* 📇 GRID DE CARDS */}
                <div className="row g-3">
                    {funcionarios.map((tabela) => (
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6" key={tabela.chapa}>
                            <CardPedido
                                clickDelete={(chapa, nome) => confirmDeleteUser(chapa, nome, tabela.foto)}
                                id={tabela.chapa}
                                chapa={tabela.chapa}
                                nome={tabela.nome}
                                data={tabela.data}
                                marmitex={tabela.marmitex}
                                opcao={tabela.opcao}
                                menu={tabela.menu}
                                observacao={tabela.observacao}
                                status={tabela.status}
                                valor={tabela.valor}
                                loja={tabela.loja}
                                horasol={tabela.horasol}
                                horaeft={tabela.horaeft}
                                foto={tabela.foto}
                                turno={tabela.turno}
                                aniversario={tabela.aniversario} // <--- ADICIONE ESTA LINHA
                                cor={tabela.chapa > 90000 ? '#66666633' : null}
                                onFotoClick={() => abrirModalFoto(tabela.foto, tabela.nome, tabela.chapa)}
                            />
                        </div>
                    ))}

                    {funcionarios.length === 0 && !loading && (
                        <div className="empty-state">
                            <i className="fa fa-search fa-3x"></i>
                            <p>Nenhum registro encontrado para este filtro.</p>
                        </div>
                    )}
                </div>

                {/* MODAL DE SENHA TEMPORÁRIA */}
                <Modal show={showModalSenha} onHide={() => setShowModalSenha(false)} centered size="sm">
                    <Modal.Header closeButton className="border-0 pb-0">
                        <Modal.Title className="h5 fw-bold text-center w-100">
                            {modoModalSenha === 'definir' ? 'Criar Senha Temporária' : 'Desbloquear Valores'}
                        </Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={handleSalvarSenhaModal}>
                        <Modal.Body className="py-3">
                            {modoModalSenha === 'definir' ? (
                                <>
                                    <p className="text-muted small mb-3 text-center">
                                        Defina uma senha temporária para ocultar/exibir os valores nesta sessão.
                                    </p>
                                    <Form.Group className="mb-2">
                                        <Form.Label className="small fw-semibold">Senha</Form.Label>
                                        <Form.Control
                                            type="password"
                                            value={inputSenha}
                                            onChange={e => setInputSenha(e.target.value)}
                                            placeholder="Digite uma senha"
                                            required
                                            autoFocus
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-2">
                                        <Form.Label className="small fw-semibold">Confirmar Senha</Form.Label>
                                        <Form.Control
                                            type="password"
                                            value={inputSenhaConfirma}
                                            onChange={e => setInputSenhaConfirma(e.target.value)}
                                            placeholder="Repita a senha"
                                            required
                                        />
                                    </Form.Group>
                                </>
                            ) : (
                                <>
                                    <p className="text-muted small mb-3 text-center">
                                        Informe sua senha temporária para exibir os valores.
                                    </p>
                                    <Form.Group className="mb-2">
                                        <Form.Label className="small fw-semibold">Senha</Form.Label>
                                        <Form.Control
                                            type="password"
                                            value={inputSenha}
                                            onChange={e => setInputSenha(e.target.value)}
                                            placeholder="Sua senha temporária"
                                            required
                                            autoFocus
                                        />
                                    </Form.Group>
                                </>
                            )}
                        </Modal.Body>
                        <Modal.Footer className="border-0 pt-0">
                            <Button type="submit" variant="primary" className="w-100 fw-bold rounded-pill">
                                {modoModalSenha === 'definir' ? 'Ocultar e Salvar' : 'Desbloquear'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* MODAL DE CONFIRMAÇÃO COM FOTO DA PESSOA */}
                <Modal show={confirmacao} onHide={() => setConfirmacao(false)} centered className="custom-modal">
                    <Modal.Header closeButton className="border-0 pb-0">
                        <Modal.Title className="fw-bold">Confirmar Refeição</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center py-3">
                        <p className="text-success fw-semibold mb-3">Deseja confirmar a entrega da refeição para:</p>

                        <div className="d-flex justify-content-center mb-3">
                            {confirmacaoUsuario?.foto ? (
                                <img
                                    src={confirmacaoUsuario.foto}
                                    alt={confirmacaoUsuario.nome}
                                    className="rounded-circle shadow-sm border border-2 border-primary"
                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                />
                            ) : (
                                <div
                                    className="rounded-circle bg-light d-flex align-items-center justify-content-center text-secondary border border-2"
                                    style={{ width: '100px', height: '100px', fontSize: '2.5rem' }}
                                >
                                    <i className="fa fa-user"></i>
                                </div>
                            )}
                        </div>

                        <h4 className="text-primary fw-bold mb-1">{confirmacaoUsuario?.nome}</h4>
                        <small className="text-muted d-block">Chapa: {confirmacaoUsuario?.chapa}</small>
                    </Modal.Body>
                    <Modal.Footer className="border-0 pt-0 justify-content-center gap-2">
                        <Button variant="light" className="px-4 fw-semibold" onClick={() => setConfirmacao(false)}>
                            Cancelar
                        </Button>
                        <Button
                            variant="success"
                            className="px-4 fw-bold"
                            onClick={() => atualizaRefeicao(confirmacaoUsuario?.chapa)}
                        >
                            Sim, Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={erro} onHide={() => setErro(false)} centered>
                    <Modal.Header closeButton className="bg-danger text-white">
                        <Modal.Title>Erro na Operação</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center py-4">
                        Houve uma falha ao processar a requisição. Tente novamente.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setErro(false)}>Fechar</Button>
                    </Modal.Footer>
                </Modal>

                <Foto
                    show={!!fotoSelecionada}
                    onClose={() => setFotoSelecionada(null)}
                    foto={fotoSelecionada?.foto}
                    nome={fotoSelecionada?.nome}
                    info01={`Chapa: ${fotoSelecionada?.chapa || ''}`}
                    info02=""
                />

                {/* TOAST FLUTUANTE DE CARREGANDO FOTOS COM CONTADOR */}
                {carregandoFotos && (
                    <div className="toast-fotos-loading">
                        <div className="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
                        <span>Carregando fotos: {fotosCarregadas}/{fotosTotal}</span>
                    </div>
                )}
            </div>

            {/* ESTILO CSS INLINE */}
            <style>{`
                .toast-fotos-loading {
                    position: fixed;
                    bottom: 25px;
                    right: 25px;
                    background: rgba(255, 255, 255, 0.95);
                    border: 1px solid #e2e8f0;
                    color: #334155;
                    padding: 10px 18px;
                    border-radius: 30px;
                    font-size: 14px;
                    font-weight: 600;
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15);
                    display: flex;
                    align-items: center;
                    z-index: 1050;
                    backdrop-filter: blur(8px);
                    animation: fadeIn 0.3s ease-in-out;
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>

            {!loading && <Footer />}
        </div>
    );
}

export default Home;